var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BasePageContainer',{staticClass:"pt-10 px-2"},[_c('PageHeader',{attrs:{"has-back":"","with-members":""}},[_vm._v(" テスト成績管理 ")]),_c('AcademicRecordsForm',{ref:"form",attrs:{"existing-academic-records":_vm.academicRecords,"user-id":_vm.userId},on:{"submit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }